import { z } from 'zod';
import { BaseEventSchema } from '../Base';

export const SearchEventSchema = BaseEventSchema.extend({
  search_string: z.string(),
  search_results: z.number(),
  search_load_more_iteration: z.number().optional(),
  search_perfect_results: z.number(),
  search_not_perfect_results: z.number(),
});

export enum SearchInteractionEventTypes {
  Search = 'interaction.search',
  SearchLoadMore = 'interaction.search.load_more',
}

export const SearchInteractionEventTrackingSchemas = {
  [SearchInteractionEventTypes.Search]: SearchEventSchema,
  [SearchInteractionEventTypes.SearchLoadMore]: SearchEventSchema,
};
